module.exports = __webpack_public_path__ + "img/63feb97.jpg";